<div class="main-layout">
  <app-partner-style *ngIf="partnerBrandService.data.partner && partnerBrandService.data.partner.brand"></app-partner-style>
  <app-header class="open-header"></app-header>
  <div class="open-content">
    <router-outlet></router-outlet>
  </div>
</div>